import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { useRelations } from '@hooks/useAgencyPublication'
import { useRelations as usePublicationRelations } from '@hooks/usePublication'

import type { AgencyPublicationModel } from '@models/types'

interface AgencyPublicationListItemProps {
  agencyPublication: AgencyPublicationModel,
}
const AgencyPublicationListItem = (props: AgencyPublicationListItemProps) => {
  const { agencyPublication: initAgencyPublication, ...restProps } = props

  const {
    publication,
    publication: {
      // @ts-expect-error TS2339
      id,
      // @ts-expect-error TS2339
      title,
    },
  } = useRelations(initAgencyPublication)

  const { provider } = usePublicationRelations(publication)

  return (
    <DashboardModuleListItem
      // @ts-expect-error TS2339
      secondaryText={provider?.title}
      title={title}
      {...restProps}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default AgencyPublicationListItem
